import * as React from "react";
import InputSetupWizardProvider from "./contexts/InputSetupWizardProvider";
import Wizard from "./Wizard";
const InputSetupWizard = ({ show, input, onClose }) => /* @__PURE__ */ React.createElement(InputSetupWizardProvider, null, /* @__PURE__ */ React.createElement(Wizard, { show, input, onClose }));
export default InputSetupWizard;
